<template>
  <v-layout align-start>
    <v-flex>
      <v-container fluid>
        <v-card outlined>
          <v-data-table :headers="headers" :items="Accruals" :search="search" flat>
            <template v-slot:top>
              <v-toolbar flat>
                <v-toolbar-title>Devengos</v-toolbar-title>
                <v-divider class="mx-4" inset vertical></v-divider>
                <v-spacer></v-spacer>
                <v-text-field class="text-xs-center" v-model="search" append-icon="search" label="Buscar" single-line
                  hide-details>
                </v-text-field>
                <v-spacer></v-spacer>
                <v-dialog v-model="dialog" max-width="40%">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn color="success" outlined v-bind="attrs" @click="clearAccruals" v-on="on">
                      Nuevo devengo
                    </v-btn>
                  </template>
                  <v-card>
                    <v-card-title>
                      <span class="headline">{{ formTitle }}</span>
                    </v-card-title>

                    <v-card-text>
                      <v-container fluid>
                        <v-row>
                          <v-col cols="12" sm="6" md="6">
                            <v-text-field v-model="newAccrual.description_long" label="Nombre" outlined dense
                              hide-details></v-text-field>
                          </v-col>
                          <v-col cols="12" sm="6" md="6">
                            <v-text-field v-model="newAccrual.description_short" label="Nombre corto" outlined dense
                              hide-details></v-text-field>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col cols="12" md="6">
                            <v-autocomplete v-model="newAccrual.payment_type_id" :items="itemsPaymentTypes"
                              label="Tipo de pago" inset outlined dense hide-details></v-autocomplete>
                          </v-col>
                          <v-col cols="12" md="6">
                            <v-switch v-model="newAccrual.has_social_security" label="Seguridad social" inset></v-switch>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col cols="12" md="6">
                            <v-switch v-model="newAccrual.apply_isr" label="Impuesto sobre la renta" inset></v-switch>
                          </v-col>
                          <v-col cols="12" md="6">
                            <v-switch v-model="accrual_status" @click="disableNotification" label="Activo"
                              inset></v-switch>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col cols="12" sm="6" md="6">
                            <v-autocomplete dense item-value="id" item-text="name"
                              v-model="newAccrual.debit_chart_of_account_id" :items="accounts" color="cyanText"
                              label="Cuenta debito" outlined required></v-autocomplete>
                          </v-col>

                          <v-col cols="12" sm="6" md="6">
                            <v-autocomplete dense item-value="id" item-text="name"
                              v-model="newAccrual.credit_chart_of_account_id" :items="accounts" color="cyanText"
                              label="Cuenta credito" outlined required></v-autocomplete>
                          </v-col>
                        </v-row>
                      </v-container>
                    </v-card-text>

                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="success" text @click="save"> Guardar </v-btn>
                      <v-btn color="red darken-1" text @click="close"> Cancelar </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </v-toolbar>
            </template>
            <template v-slot:[`item.actions`]="{ item }">
              <v-icon large color="accent" class="mr-2" @click="editItem(item)">
                edit
              </v-icon>
            </template>
            <template v-slot:no-data>
              <v-btn color="primary" @click="initialize"> Reset </v-btn>
            </template>
          </v-data-table>
        </v-card>
      </v-container>
    </v-flex>
  </v-layout>
</template>

<script>
export default {
  data: () => ({
    dialog: false,
    headers: [
      {
        text: "Codigo",
        align: "start",
        value: "id",
      },
      { text: "Descripcion", value: "description_long" },
      { text: "Descripcion corta", value: "description_short" },
      { text: "Metodo de pago", value: "payment_type_description" },
      { text: "Actions", value: "actions", sortable: false },
    ],
    search: "",
    Accruals: [],
    accounts: [],
    newAccrual: {
      id: null,
      description_long: null,
      description_short: null,
      payment_type_id: null,
      has_social_security: false,
      apply_isr: false,
      status_id: 1,
    },
    accrual_status: true,
    itemsCities: [],
    itemsPaymentTypes: [],
    editedIndex: -1,
    editedItem: {
      description: "",
    },
    defaultItem: {
      descripcion: "",
    },
  }),
  components: {
    // Barra
  },
  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "Nuevo devengo" : "Editar devengo";
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
  },

  created() {
    this.initialize();
  },

  methods: {
    async initialize() {
      this.getData();
      let resultTypeAccounts = await this.api_Get("accounting/accountsUsable");
      let accounts=await resultTypeAccounts.json();
      accounts.forEach(element => {
        element.name=element.name+" (" +element.code+")"
        this.accounts.push({
          name: element.code+" - "+ element.name,
          id: element.id,
        
        })
      });
      //combo payment Types---------------------------------------------
      this.itemsPaymentTypes = await this.g_ComboGeneric("humanResource/paymentTypes");
    },
    async getData() {
      const result = await this.api_Get("humanResource/accruals");
      const data = await result.json();
      this.Accruals = data;
    },
    editItem(item) {
      this.editedIndex = this.Accruals.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.newAccrual = this.Accruals[this.editedIndex];
      this.newAccrual.status_id === 1
        ? (this.accrual_status = true)
        : (this.accrual_status = false);
      this.newAccrual.contact_type = 3;
      this.dialog = true;
    },
    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },
    async save() {
      // var datos = this.editedItem;
      if (this.accrual_status == false) {
        this.newAccrual.status_id = 3;
      } else {
        this.newAccrual.status_id = 1;
      }
      let datos = {
        id: this.newAccrual.id,
        description_long: this.newAccrual.description_long.trim(),
        description_short: this.newAccrual.description_short,
        payment_type_id: this.newAccrual.payment_type_id,
        has_social_security: this.newAccrual.has_social_security,
        debit_chart_of_account_id: this.newAccrual.debit_chart_of_account_id,
        credit_chart_of_account_id: this.newAccrual.credit_chart_of_account_id,
        apply_isr: this.newAccrual.apply_isr,
        status_id: this.newAccrual.status_id,
      };
      if (this.editedIndex > -1) {
        //Modificar
        const result = await this.api_Put("humanResource/accruals", datos);
        if (result.status == 200) {
          this.$toast.success("Actualizado con exito!");
        } else {
          this.$toast.error("Ha ocurrido un error!");
        }
      } else {
        //Crear nuevo
        const result = await this.api_Post("humanResource/accruals", datos);
        if (result.status == 200) {
          this.$toast.success("Registrado con exito!");
          this.dialog = false;
          this.getData();
        } else {
          this.$toast.error("Ha ocurrido un error!");
        }
      }

      this.close();
    },
    clearAccruals() {
      this.newAccrual = {
        id: null,
        description_long: null,
        description_short: null,
        payment_type_id: null,
        has_social_security: false,
        apply_isr: false,
        status_id: 1,
      };
      this.accrual_status = true;
    },
    disableNotification() {
      if (this.accrual_status == false) {
        this.warningNotification("Se desactivara este devengo!");
      }
    },
  },
};
</script>
